import {Component, OnInit} from '@angular/core';
import {JobApplicationService} from '../job-application/job-application.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-browse-application',
  templateUrl: './browse-application.component.html',
  styleUrls: ['./browse-application.component.css']
})
export class BrowseApplicationComponent implements OnInit {
  vacancy: any;
  showDetails: boolean;

  constructor(
    private jobApplicationService: JobApplicationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.getVacancyById(this.route.snapshot.params.vacantId);
  }

  getVacancyById(vacantId: bigint) {
    return this.jobApplicationService.getVacancyById(vacantId)
      .subscribe(response => {
        this.vacancy = response;
        if (this.vacancy == null) {
          this.showDetails = false;
        } else {
          this.showDetails = true;
        }
      });
  }

  backToMyApplications() {
    return this.router.navigate(['/dashboard/manage-applications']).then(window.location.reload);
  }
}
